import { queries } from "../../shared/queries";
import { config } from "../environment";
import { deriveShowFeatureFlagsNav } from "./deriveShowFeatureFlagsNav";
import { useQuery } from "./useQuery";

export function useShowFeatureFlagsNav(): boolean {
  const [prefs] = useQuery(queries.userPreferences());
  return deriveShowFeatureFlagsNav(
    prefs?.showFeatureFlagsNav,
    config.showFeatureFlagsNavDefault
  );
}
